import { Group, SaveButton } from '@/components/_common';
import {
  useCompanySettings,
  useCreateCompanySettings,
  useUpdateCompanySettings,
} from '@/core/domain/enterprise/Companies/Companies.hooks';
import { useEffect, useRef } from 'react';
import { useRouteMatch } from 'react-router-dom';
import CompanyMichelinForm, { CompanyMichelinRef } from './CompanyMichelinForm';
import { Typography } from 'antd';
import { useWindowSize } from '@/hooks';

export default function IntegrationMichelinSettings() {
  const { width } = useWindowSize();

  const companyMichelinRef = useRef<CompanyMichelinRef>(null);

  const { companyId } = useRouteMatch<{ companyId: string }>().params;
  const { data, isLoading } = useCompanySettings(+companyId);
  const createMutation = useCreateCompanySettings(
    'A configuração da Michelin foi criada com sucesso',
  );
  const updateMutation = useUpdateCompanySettings(
    'A configuração da Michelin foi alterada com sucesso',
  );

  useEffect(() => {
    if (data) {
      companyMichelinRef.current?.setFieldsValue(data);
    }
  }, [data]);

  const handleSave = async () => {
    if (companyMichelinRef.current?.validateFields) {
      const values = await companyMichelinRef.current?.validateFields();
      if (!data) {
        createMutation.mutateAsync({
          ...values,
          companyId: Number(companyId),
        });
      } else {
        updateMutation.mutateAsync({
          ...data,
          ...values,
          id: data.id,
        });
      }
    }
  };

  return (
    <>
      <Group position="between">
        <Typography.Title level={4} style={{ margin: 0 }}>
          Michelin
        </Typography.Title>

        {!(width < 992) && (
          <SaveButton type="primary" onClick={handleSave}>
            Salvar
          </SaveButton>
        )}
      </Group>

      <CompanyMichelinForm ref={companyMichelinRef} isLoading={isLoading} />
    </>
  );
}
